import { CamposGenericos } from "./camposGenericos";

export class TipoNC extends CamposGenericos {
    descripcion: string;
    id: string;
    idPais: string;
    lote: boolean;
}